/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Source_Group_HelpInputs */



/**
* | output |
* | --- |
* | "Select the group to copy timecodes from" |
*
* @param {Source_Group_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const source_group_help = /** @type {((inputs?: Source_Group_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Source_Group_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sélectionnez le groupe dont copier les timecodes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie die Gruppe aus, aus der die Timecodes kopiert werden sollen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona il gruppo da cui copiare i timecode")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите группу, из которой нужно скопировать временные коды.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccione el grupo desde el cual copiar códigos de tiempo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择要从中复制时间码的组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タイムコードをコピーするグループを選択します")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टाइमकोड कॉपी करने के लिए समूह का चयन करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione o grupo do qual deseja copiar os códigos de tempo.")
	return /** @type {LocalizedString} */ ("Select the group to copy timecodes from")
});